import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "../pages/Dashboard";
import { Zap, AlertOctagon, AlertTriangle, Info } from "lucide-react";
import ConfidenceBar from "@/components/ConfidenceBar";

// Read-only headline tile on the Overview dashboard.
// Hides itself when there's nothing to surface. NO writes, NO apply buttons.

const SEV_META = {
  critical: { tone: "text-red-700",    Icon: AlertOctagon },
  warning:  { tone: "text-amber-700",  Icon: AlertTriangle },
  info:     { tone: "text-[#1D4ED8]",  Icon: Info },
};

export default function AutomationPreviewCard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.post("/automation/preview/overview-summary", { limit: 5 })
      .then((r) => setData(r.data))
      .catch(() => setData({ recommendations: [], summary: { total: 0 } }));
  }, []);
  if (!data) return null;
  const recs = data.recommendations || [];
  if (recs.length === 0) return null;
  return (
    <Card data-testid="dash-automation-preview"
      title={<span className="flex items-center gap-2">
        <Zap className="h-4 w-4 text-[#2563EB]" />Automation insights
        <span className="text-[9px] uppercase tracking-widest text-[#1D4ED8] px-1 py-0 rounded bg-[#DBE7FE] border border-[#BFD3FB]"
          data-testid="dash-automation-advanced">Advanced</span>
      </span>}
      action={
        <Link to="/app/automation" className="text-xs text-[#2563EB] hover:underline">
          Open the full report →
        </Link>}
    >
      <div className="flex items-center gap-3 mb-3 flex-wrap">
        <span className="text-[11px] text-[#4B5773]">Overall confidence</span>
        <ConfidenceBar value={data.summary?.confidence ?? 1}
          testid="dash-automation-confidence" />
      </div>
      <ul className="space-y-2">
        {recs.slice(0, 5).map((r, i) => {
          const m = SEV_META[r.severity] || SEV_META.info;
          const Icon = m.Icon;
          return (
            <li key={i} data-testid={`dash-automation-item-${i}`}
                className="flex items-start gap-2 text-sm">
              <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${m.tone}`} />
              <div className="min-w-0">
                <div className="font-medium text-[#0B1A36] truncate">{r.title}</div>
                <div className="text-[11px] text-[#4B5773] truncate">{r.message}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
